export default {
  en: {
    refCode: 'Ref Code',
    autoGenRefCode: 'Auto generate Ref Code',
    specialOfferValidFrom: 'Special Offer Valid From',
    salePerson: 'Sales Person',
    pleaseSelectSalePerson: 'Please select sale person',
    issueDate: 'Issue Date',
    bodyMessage: 'Body Message',
    footerMessage: 'Footer Message',
    internalNote: 'Internal Note',
    agentName: 'Agent Name',
    runningIndex: 'Running Index',
    randomNumber: 'Random Number',
    addSignatureInSpecialOffer: 'Add signature in special offer',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedSalePersonMessage: 'This sale person has been updated',
    deletedSalePersonMessage: 'This sale person has been deleted'
  },
  th: {
    refCode: 'รหัสอ้างอิง',
    autoGenRefCode: 'สร้างรหัสอ้างอิงอัตโนมัติ',
    specialOfferValidFrom: 'ระยะเวลาข้อเสนอพิเศษ',
    salePerson: 'พนักงานขาย',
    pleaseSelectSalePerson: 'กรุณาเลือกพนักงานขาย',
    issueDate: 'วันที่',
    bodyMessage: 'ข้อความ',
    footerMessage: 'ข้อความต่อท้าย',
    internalNote: 'หมายเหตุ',
    agentName: 'ชื่อตัวแทน',
    runningIndex: 'Running Index',
    randomNumber: 'Random Number',
    addSignatureInSpecialOffer: 'เพิ่มลายเซ็นในข้อเสนอพิเศษ',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedSalePersonMessage: 'มีการแก้ไขพนักงานขาย',
    deletedSalePersonMessage: 'พนักงานขายถูกลบไปแล้ว'
  }
}
